import { Piece } from '@/game/tetrisEngine';
import { useLanguage } from '@/contexts/LanguageContext';

interface NextPieceProps {
  piece: Piece | null;
}

export function NextPieceDisplay({ piece }: NextPieceProps) {
  const { t } = useLanguage();
  if (!piece) return null;

  return (
    <div className="glass-card p-4 next-piece-context">
      <h3 className="text-sm font-semibold text-muted-foreground mb-2 uppercase tracking-wider">{t.score.nextPiece}</h3>
      <div className="grid gap-[2px] w-fit mx-auto" style={{ gridTemplateColumns: `repeat(${piece.shape[0].length}, 20px)` }}>
        {piece.shape.flat().map((cell, i) => (
          <div
            key={i}
            className={`w-5 h-5 rounded-[2px] ${cell ? `tetris-${piece.type}` : 'bg-transparent'}`}
          />
        ))}
      </div>
    </div>
  );
}
